import React, { Component } from 'react';
import './TopBar.css';

export class TopBar extends Component {
    state = {
        userName: 'Admin User',
        currentPage: '',
        sidebarCollapsed: false
    }

    componentDidMount() {
        this._isMounted = true;
        this.getUserInfo();
        this.getCurrentPage(this.props.currentPath);
        this.checkSidebarState();

        // Listen for sidebar state changes via storage event
        this.handleStorageChange = (e) => {
            if (e.key === 'sidebarCollapsed') {
                this.checkSidebarState();
            }
        };
        window.addEventListener('storage', this.handleStorageChange);

        // Fallback check (less frequent)
        this.sidebarCheckInterval = setInterval(() => {
            this.checkSidebarState();
        }, 500);
    }

    componentWillUnmount() {
        this._isMounted = false;
        if (this.sidebarCheckInterval) {
            clearInterval(this.sidebarCheckInterval);
        }
        if (this.handleStorageChange) {
            window.removeEventListener('storage', this.handleStorageChange);
        }
    }

    checkSidebarState = () => {
        if (this._isMounted) {
            const collapsed = JSON.parse(localStorage.getItem('sidebarCollapsed') || 'false');
            if (collapsed !== this.state.sidebarCollapsed) {
                this.setState({ sidebarCollapsed: collapsed });
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentPath !== this.props.currentPath) {
            this.getCurrentPage(this.props.currentPath);
        }
    }

    getUserInfo = () => {
        const userName = localStorage.getItem('userName') || 'User';
        this.setState({ userName });
    }



    getCurrentPage = (path = window.location.pathname) => {

        const PAGE_NAMES = {
            '/home': 'Dashboard',
            '/dashboard': 'Dashboard',
            '/suppliers-data': 'Suppliers',
            '/purchases': 'Purchases',
            '/inventory': 'Inventory',
            '/parts': 'Parts',
            '/users': 'Users Management',
            '/admin-suppliers': 'Suppliers Management',
            '/roles': 'Roles Management',
            '/library': 'Library',
            '/purchasing-library': 'Purchasing Library',
            '/quoting-history': 'Quoting History',
            '/vendors': 'Vendors',
            '/add-raws': 'Add Part',
            '/compare-quotes': 'Compare Quotes',
            '/add-supplier': 'Add Supplier',
            '/import-suppliers': 'Import Suppliers',
            '/request-quote': 'Request for Quote Repository',
            '/formula': 'Formula Repository',
            '/draft-estimate': 'Estimate',
            '/estimate': 'Quotation',
            '/overview': 'Overview',
            '/monthly-shipping-cost': 'Monthly Shipping Cost',
            '/all-jobs': 'All Jobs'
        };


        const cleanPath = path.split('?')[0];
        
        let pageName = PAGE_NAMES[cleanPath] || 'Dashboard';
        
        // Handle dynamic routes
        if (!PAGE_NAMES[path]) {
            if (path.includes('/view/')) {
                pageName = 'View Record';
            } else if (path.includes('/view-raws/')) {
                pageName = 'View Part';
            } else if (path.includes('/add-supplier-record')) {
                pageName = 'Add Record';
            } else if (path.includes('/suppliers-data/')) {
                pageName = 'Suppliers';
            } else if (cleanPath.startsWith('/draft-estimate/view')) {
                pageName = 'Costing Analysis (View Only)';
            } else if (cleanPath.startsWith('/draft-estimate/edit')) {
                pageName = 'Costing Analysis';
            } else if (cleanPath.startsWith('/request-quote/new')) {
                pageName = 'Request for Quote';
            } else if (cleanPath.startsWith('/request-quote/edit')) {
                pageName = 'Edit Request for Quote';
            } else if (cleanPath.startsWith('/formula/new')) {
                pageName = 'Add New Formula';
            } else if (cleanPath.startsWith('/formula/edit')) {
                pageName = 'Edit Formula';
            } else if (cleanPath.startsWith('/estimate/edit')) {
                pageName = 'Estimate (view only)';
            } else if (cleanPath.startsWith('/compare-quotes')) {
                pageName = 'Compare Quotes';
            }
        }
        
        this.setState({ currentPage: pageName });
    }


    render() {
        const { userName, currentPage } = this.state;

        return (
            <div className="topbar">
                <div className="topbar-left">
                    <div className="title-section">
                        <h1 className="topbar-title">{currentPage}</h1>
                    </div>
                </div>
                <div className="topbar-right">
                    <div className="user-info">
                        <span className="user-greeting">Welcome back, {userName}</span>
                    </div>
                </div>
            </div>
        );
    }

    handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('userName');
        localStorage.removeItem('suppliersSearch');
        localStorage.removeItem('suppliersSelectedOption');
        localStorage.removeItem('suppliersSelectedOptionName');
        localStorage.removeItem('suppliersPageSize');
        localStorage.removeItem('rawsPerPage');
        localStorage.removeItem('purchasesPerPage');
        window.location.href = "/login";
    }
}

export default TopBar;